import template from './scores_page.html'

export default {
  template,
  controller: 'scoresPageController as scoresPage'
}
